export default "__VITE_ASSET__a0f83b68__"